/**
 * Phone countries sorted by dial code (numeric), then by name for shared codes.
 */
const PHONE_COUNTRIES_BY_DIAL_CODE = [
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1"
  },
  {
    "name": "Dominican Republic",
    "iso2": "do",
    "dialCode": "1"
  },
  {
    "name": "Puerto Rico",
    "iso2": "pr",
    "dialCode": "1"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1"
  },
  {
    "name": "Kazakhstan",
    "iso2": "kz",
    "dialCode": "7"
  },
  {
    "name": "Russia",
    "iso2": "ru",
    "dialCode": "7"
  },
  {
    "name": "Egypt",
    "iso2": "eg",
    "dialCode": "20"
  },
  {
    "name": "South Africa",
    "iso2": "za",
    "dialCode": "27"
  },
  {
    "name": "Greece",
    "iso2": "gr",
    "dialCode": "30"
  },
  {
    "name": "Netherlands",
    "iso2": "nl",
    "dialCode": "31"
  },
  {
    "name": "Belgium",
    "iso2": "be",
    "dialCode": "32"
  },
  {
    "name": "France",
    "iso2": "fr",
    "dialCode": "33"
  },
  {
    "name": "Spain",
    "iso2": "es",
    "dialCode": "34"
  },
  {
    "name": "Hungary",
    "iso2": "hu",
    "dialCode": "36"
  },
  {
    "name": "Italy",
    "iso2": "it",
    "dialCode": "39"
  },
  {
    "name": "Vatican City",
    "iso2": "va",
    "dialCode": "39"
  },
  {
    "name": "Romania",
    "iso2": "ro",
    "dialCode": "40"
  },
  {
    "name": "Switzerland",
    "iso2": "ch",
    "dialCode": "41"
  },
  {
    "name": "Austria",
    "iso2": "at",
    "dialCode": "43"
  },
  {
    "name": "United Kingdom",
    "iso2": "gb",
    "dialCode": "44"
  },
  {
    "name": "Denmark",
    "iso2": "dk",
    "dialCode": "45"
  },
  {
    "name": "Sweden",
    "iso2": "se",
    "dialCode": "46"
  },
  {
    "name": "Norway",
    "iso2": "no",
    "dialCode": "47"
  },
  {
    "name": "Poland",
    "iso2": "pl",
    "dialCode": "48"
  },
  {
    "name": "Germany",
    "iso2": "de",
    "dialCode": "49"
  },
  {
    "name": "Peru",
    "iso2": "pe",
    "dialCode": "51"
  },
  {
    "name": "Mexico",
    "iso2": "mx",
    "dialCode": "52"
  },
  {
    "name": "Cuba",
    "iso2": "cu",
    "dialCode": "53"
  },
  {
    "name": "Argentina",
    "iso2": "ar",
    "dialCode": "54"
  },
  {
    "name": "Brazil",
    "iso2": "br",
    "dialCode": "55"
  },
  {
    "name": "Chile",
    "iso2": "cl",
    "dialCode": "56"
  },
  {
    "name": "Colombia",
    "iso2": "co",
    "dialCode": "57"
  },
  {
    "name": "Venezuela",
    "iso2": "ve",
    "dialCode": "58"
  },
  {
    "name": "Malaysia",
    "iso2": "my",
    "dialCode": "60"
  },
  {
    "name": "Australia",
    "iso2": "au",
    "dialCode": "61"
  },
  {
    "name": "Indonesia",
    "iso2": "id",
    "dialCode": "62"
  },
  {
    "name": "Philippines",
    "iso2": "ph",
    "dialCode": "63"
  },
  {
    "name": "New Zealand",
    "iso2": "nz",
    "dialCode": "64"
  },
  {
    "name": "Singapore",
    "iso2": "sg",
    "dialCode": "65"
  },
  {
    "name": "Thailand",
    "iso2": "th",
    "dialCode": "66"
  },
  {
    "name": "Japan",
    "iso2": "jp",
    "dialCode": "81"
  },
  {
    "name": "South Korea",
    "iso2": "kr",
    "dialCode": "82"
  },
  {
    "name": "Vietnam",
    "iso2": "vn",
    "dialCode": "84"
  },
  {
    "name": "China",
    "iso2": "cn",
    "dialCode": "86"
  },
  {
    "name": "Turkey",
    "iso2": "tr",
    "dialCode": "90"
  },
  {
    "name": "India",
    "iso2": "in",
    "dialCode": "91"
  },
  {
    "name": "Pakistan",
    "iso2": "pk",
    "dialCode": "92"
  },
  {
    "name": "Afghanistan",
    "iso2": "af",
    "dialCode": "93"
  },
  {
    "name": "Sri Lanka",
    "iso2": "lk",
    "dialCode": "94"
  },
  {
    "name": "Myanmar",
    "iso2": "mm",
    "dialCode": "95"
  },
  {
    "name": "Iran",
    "iso2": "ir",
    "dialCode": "98"
  },
  {
    "name": "South Sudan",
    "iso2": "ss",
    "dialCode": "211"
  },
  {
    "name": "Morocco",
    "iso2": "ma",
    "dialCode": "212"
  },
  {
    "name": "Algeria",
    "iso2": "dz",
    "dialCode": "213"
  },
  {
    "name": "Tunisia",
    "iso2": "tn",
    "dialCode": "216"
  },
  {
    "name": "Libya",
    "iso2": "ly",
    "dialCode": "218"
  },
  {
    "name": "Gambia",
    "iso2": "gm",
    "dialCode": "220"
  },
  {
    "name": "Senegal",
    "iso2": "sn",
    "dialCode": "221"
  },
  {
    "name": "Mauritania",
    "iso2": "mr",
    "dialCode": "222"
  },
  {
    "name": "Mali",
    "iso2": "ml",
    "dialCode": "223"
  },
  {
    "name": "Guinea",
    "iso2": "gn",
    "dialCode": "224"
  },
  {
    "name": "Côte d’Ivoire",
    "iso2": "ci",
    "dialCode": "225"
  },
  {
    "name": "Burkina Faso",
    "iso2": "bf",
    "dialCode": "226"
  },
  {
    "name": "Niger",
    "iso2": "ne",
    "dialCode": "227"
  },
  {
    "name": "Togo",
    "iso2": "tg",
    "dialCode": "228"
  },
  {
    "name": "Benin",
    "iso2": "bj",
    "dialCode": "229"
  },
  {
    "name": "Mauritius",
    "iso2": "mu",
    "dialCode": "230"
  },
  {
    "name": "Liberia",
    "iso2": "lr",
    "dialCode": "231"
  },
  {
    "name": "Sierra Leone",
    "iso2": "sl",
    "dialCode": "232"
  },
  {
    "name": "Ghana",
    "iso2": "gh",
    "dialCode": "233"
  },
  {
    "name": "Nigeria",
    "iso2": "ng",
    "dialCode": "234"
  },
  {
    "name": "Chad",
    "iso2": "td",
    "dialCode": "235"
  },
  {
    "name": "Central African Republic",
    "iso2": "cf",
    "dialCode": "236"
  },
  {
    "name": "Cameroon",
    "iso2": "cm",
    "dialCode": "237"
  },
  {
    "name": "Cape Verde",
    "iso2": "cv",
    "dialCode": "238"
  },
  {
    "name": "São Tomé and Príncipe",
    "iso2": "st",
    "dialCode": "239"
  },
  {
    "name": "Equatorial Guinea",
    "iso2": "gq",
    "dialCode": "240"
  },
  {
    "name": "Gabon",
    "iso2": "ga",
    "dialCode": "241"
  },
  {
    "name": "Congo",
    "iso2": "cg",
    "dialCode": "242"
  },
  {
    "name": "Congo",
    "iso2": "cd",
    "dialCode": "243"
  },
  {
    "name": "Angola",
    "iso2": "ao",
    "dialCode": "244"
  },
  {
    "name": "Guinea-Bissau",
    "iso2": "gw",
    "dialCode": "245"
  },
  {
    "name": "British Indian Ocean Territory",
    "iso2": "io",
    "dialCode": "246"
  },
  {
    "name": "Seychelles",
    "iso2": "sc",
    "dialCode": "248"
  },
  {
    "name": "Sudan",
    "iso2": "sd",
    "dialCode": "249"
  },
  {
    "name": "Rwanda",
    "iso2": "rw",
    "dialCode": "250"
  },
  {
    "name": "Ethiopia",
    "iso2": "et",
    "dialCode": "251"
  },
  {
    "name": "Somalia",
    "iso2": "so",
    "dialCode": "252"
  },
  {
    "name": "Djibouti",
    "iso2": "dj",
    "dialCode": "253"
  },
  {
    "name": "Kenya",
    "iso2": "ke",
    "dialCode": "254"
  },
  {
    "name": "Tanzania",
    "iso2": "tz",
    "dialCode": "255"
  },
  {
    "name": "Uganda",
    "iso2": "ug",
    "dialCode": "256"
  },
  {
    "name": "Burundi",
    "iso2": "bi",
    "dialCode": "257"
  },
  {
    "name": "Mozambique",
    "iso2": "mz",
    "dialCode": "258"
  },
  {
    "name": "Zambia",
    "iso2": "zm",
    "dialCode": "260"
  },
  {
    "name": "Madagascar",
    "iso2": "mg",
    "dialCode": "261"
  },
  {
    "name": "Réunion",
    "iso2": "re",
    "dialCode": "262"
  },
  {
    "name": "Zimbabwe",
    "iso2": "zw",
    "dialCode": "263"
  },
  {
    "name": "Namibia",
    "iso2": "na",
    "dialCode": "264"
  },
  {
    "name": "Malawi",
    "iso2": "mw",
    "dialCode": "265"
  },
  {
    "name": "Lesotho",
    "iso2": "ls",
    "dialCode": "266"
  },
  {
    "name": "Botswana",
    "iso2": "bw",
    "dialCode": "267"
  },
  {
    "name": "Swaziland",
    "iso2": "sz",
    "dialCode": "268"
  },
  {
    "name": "Comoros",
    "iso2": "km",
    "dialCode": "269"
  },
  {
    "name": "Saint Helena",
    "iso2": "sh",
    "dialCode": "290"
  },
  {
    "name": "Eritrea",
    "iso2": "er",
    "dialCode": "291"
  },
  {
    "name": "Aruba",
    "iso2": "aw",
    "dialCode": "297"
  },
  {
    "name": "Faroe Islands",
    "iso2": "fo",
    "dialCode": "298"
  },
  {
    "name": "Greenland",
    "iso2": "gl",
    "dialCode": "299"
  },
  {
    "name": "Gibraltar",
    "iso2": "gi",
    "dialCode": "350"
  },
  {
    "name": "Portugal",
    "iso2": "pt",
    "dialCode": "351"
  },
  {
    "name": "Luxembourg",
    "iso2": "lu",
    "dialCode": "352"
  },
  {
    "name": "Ireland",
    "iso2": "ie",
    "dialCode": "353"
  },
  {
    "name": "Iceland",
    "iso2": "is",
    "dialCode": "354"
  },
  {
    "name": "Albania",
    "iso2": "al",
    "dialCode": "355"
  },
  {
    "name": "Malta",
    "iso2": "mt",
    "dialCode": "356"
  },
  {
    "name": "Cyprus",
    "iso2": "cy",
    "dialCode": "357"
  },
  {
    "name": "Finland",
    "iso2": "fi",
    "dialCode": "358"
  },
  {
    "name": "Bulgaria",
    "iso2": "bg",
    "dialCode": "359"
  },
  {
    "name": "Lithuania",
    "iso2": "lt",
    "dialCode": "370"
  },
  {
    "name": "Latvia",
    "iso2": "lv",
    "dialCode": "371"
  },
  {
    "name": "Estonia",
    "iso2": "ee",
    "dialCode": "372"
  },
  {
    "name": "Moldova",
    "iso2": "md",
    "dialCode": "373"
  },
  {
    "name": "Armenia",
    "iso2": "am",
    "dialCode": "374"
  },
  {
    "name": "Belarus",
    "iso2": "by",
    "dialCode": "375"
  },
  {
    "name": "Andorra",
    "iso2": "ad",
    "dialCode": "376"
  },
  {
    "name": "Monaco",
    "iso2": "mc",
    "dialCode": "377"
  },
  {
    "name": "San Marino",
    "iso2": "sm",
    "dialCode": "378"
  },
  {
    "name": "Ukraine",
    "iso2": "ua",
    "dialCode": "380"
  },
  {
    "name": "Serbia",
    "iso2": "rs",
    "dialCode": "381"
  },
  {
    "name": "Montenegro",
    "iso2": "me",
    "dialCode": "382"
  },
  {
    "name": "Croatia",
    "iso2": "hr",
    "dialCode": "385"
  },
  {
    "name": "Slovenia",
    "iso2": "si",
    "dialCode": "386"
  },
  {
    "name": "Bosnia and Herzegovina",
    "iso2": "ba",
    "dialCode": "387"
  },
  {
    "name": "Macedonia",
    "iso2": "mk",
    "dialCode": "389"
  },
  {
    "name": "Czech Republic",
    "iso2": "cz",
    "dialCode": "420"
  },
  {
    "name": "Slovakia",
    "iso2": "sk",
    "dialCode": "421"
  },
  {
    "name": "Liechtenstein",
    "iso2": "li",
    "dialCode": "423"
  },
  {
    "name": "Falkland Islands",
    "iso2": "fk",
    "dialCode": "500"
  },
  {
    "name": "Belize",
    "iso2": "bz",
    "dialCode": "501"
  },
  {
    "name": "Guatemala",
    "iso2": "gt",
    "dialCode": "502"
  },
  {
    "name": "El Salvador",
    "iso2": "sv",
    "dialCode": "503"
  },
  {
    "name": "Honduras",
    "iso2": "hn",
    "dialCode": "504"
  },
  {
    "name": "Nicaragua",
    "iso2": "ni",
    "dialCode": "505"
  },
  {
    "name": "Costa Rica",
    "iso2": "cr",
    "dialCode": "506"
  },
  {
    "name": "Panama",
    "iso2": "pa",
    "dialCode": "507"
  },
  {
    "name": "Saint Pierre and Miquelon",
    "iso2": "pm",
    "dialCode": "508"
  },
  {
    "name": "Haiti",
    "iso2": "ht",
    "dialCode": "509"
  },
  {
    "name": "Guadeloupe",
    "iso2": "gp",
    "dialCode": "590"
  },
  {
    "name": "Saint Barthélemy",
    "iso2": "bl",
    "dialCode": "590"
  },
  {
    "name": "Saint Martin",
    "iso2": "mf",
    "dialCode": "590"
  },
  {
    "name": "Bolivia",
    "iso2": "bo",
    "dialCode": "591"
  },
  {
    "name": "Guyana",
    "iso2": "gy",
    "dialCode": "592"
  },
  {
    "name": "Ecuador",
    "iso2": "ec",
    "dialCode": "593"
  },
  {
    "name": "French Guiana",
    "iso2": "gf",
    "dialCode": "594"
  },
  {
    "name": "Paraguay",
    "iso2": "py",
    "dialCode": "595"
  },
  {
    "name": "Martinique",
    "iso2": "mq",
    "dialCode": "596"
  },
  {
    "name": "Suriname",
    "iso2": "sr",
    "dialCode": "597"
  },
  {
    "name": "Uruguay",
    "iso2": "uy",
    "dialCode": "598"
  },
  {
    "name": "Caribbean Netherlands",
    "iso2": "bq",
    "dialCode": "599"
  },
  {
    "name": "Curaçao",
    "iso2": "cw",
    "dialCode": "599"
  },
  {
    "name": "Timor-Leste",
    "iso2": "tl",
    "dialCode": "670"
  },
  {
    "name": "Norfolk Island",
    "iso2": "nf",
    "dialCode": "672"
  },
  {
    "name": "Brunei",
    "iso2": "bn",
    "dialCode": "673"
  },
  {
    "name": "Nauru",
    "iso2": "nr",
    "dialCode": "674"
  },
  {
    "name": "Papua New Guinea",
    "iso2": "pg",
    "dialCode": "675"
  },
  {
    "name": "Tonga",
    "iso2": "to",
    "dialCode": "676"
  },
  {
    "name": "Solomon Islands",
    "iso2": "sb",
    "dialCode": "677"
  },
  {
    "name": "Vanuatu",
    "iso2": "vu",
    "dialCode": "678"
  },
  {
    "name": "Fiji",
    "iso2": "fj",
    "dialCode": "679"
  },
  {
    "name": "Palau",
    "iso2": "pw",
    "dialCode": "680"
  },
  {
    "name": "Wallis and Futuna",
    "iso2": "wf",
    "dialCode": "681"
  },
  {
    "name": "Cook Islands",
    "iso2": "ck",
    "dialCode": "682"
  },
  {
    "name": "Niue",
    "iso2": "nu",
    "dialCode": "683"
  },
  {
    "name": "Samoa",
    "iso2": "ws",
    "dialCode": "685"
  },
  {
    "name": "Kiribati",
    "iso2": "ki",
    "dialCode": "686"
  },
  {
    "name": "New Caledonia",
    "iso2": "nc",
    "dialCode": "687"
  },
  {
    "name": "Tuvalu",
    "iso2": "tv",
    "dialCode": "688"
  },
  {
    "name": "French Polynesia",
    "iso2": "pf",
    "dialCode": "689"
  },
  {
    "name": "Tokelau",
    "iso2": "tk",
    "dialCode": "690"
  },
  {
    "name": "Micronesia",
    "iso2": "fm",
    "dialCode": "691"
  },
  {
    "name": "Marshall Islands",
    "iso2": "mh",
    "dialCode": "692"
  },
  {
    "name": "North Korea",
    "iso2": "kp",
    "dialCode": "850"
  },
  {
    "name": "Hong Kong",
    "iso2": "hk",
    "dialCode": "852"
  },
  {
    "name": "Macau",
    "iso2": "mo",
    "dialCode": "853"
  },
  {
    "name": "Cambodia",
    "iso2": "kh",
    "dialCode": "855"
  },
  {
    "name": "Laos",
    "iso2": "la",
    "dialCode": "856"
  },
  {
    "name": "Bangladesh",
    "iso2": "bd",
    "dialCode": "880"
  },
  {
    "name": "Taiwan",
    "iso2": "tw",
    "dialCode": "886"
  },
  {
    "name": "Maldives",
    "iso2": "mv",
    "dialCode": "960"
  },
  {
    "name": "Lebanon",
    "iso2": "lb",
    "dialCode": "961"
  },
  {
    "name": "Jordan",
    "iso2": "jo",
    "dialCode": "962"
  },
  {
    "name": "Syria",
    "iso2": "sy",
    "dialCode": "963"
  },
  {
    "name": "Iraq",
    "iso2": "iq",
    "dialCode": "964"
  },
  {
    "name": "Kuwait",
    "iso2": "kw",
    "dialCode": "965"
  },
  {
    "name": "Saudi Arabia",
    "iso2": "sa",
    "dialCode": "966"
  },
  {
    "name": "Yemen",
    "iso2": "ye",
    "dialCode": "967"
  },
  {
    "name": "Oman",
    "iso2": "om",
    "dialCode": "968"
  },
  {
    "name": "Palestine",
    "iso2": "ps",
    "dialCode": "970"
  },
  {
    "name": "United Arab Emirates",
    "iso2": "ae",
    "dialCode": "971"
  },
  {
    "name": "Israel",
    "iso2": "il",
    "dialCode": "972"
  },
  {
    "name": "Bahrain",
    "iso2": "bh",
    "dialCode": "973"
  },
  {
    "name": "Qatar",
    "iso2": "qa",
    "dialCode": "974"
  },
  {
    "name": "Bhutan",
    "iso2": "bt",
    "dialCode": "975"
  },
  {
    "name": "Mongolia",
    "iso2": "mn",
    "dialCode": "976"
  },
  {
    "name": "Nepal",
    "iso2": "np",
    "dialCode": "977"
  },
  {
    "name": "Tajikistan",
    "iso2": "tj",
    "dialCode": "992"
  },
  {
    "name": "Turkmenistan",
    "iso2": "tm",
    "dialCode": "993"
  },
  {
    "name": "Azerbaijan",
    "iso2": "az",
    "dialCode": "994"
  },
  {
    "name": "Georgia",
    "iso2": "ge",
    "dialCode": "995"
  },
  {
    "name": "Kyrgyzstan",
    "iso2": "kg",
    "dialCode": "996"
  },
  {
    "name": "Uzbekistan",
    "iso2": "uz",
    "dialCode": "998"
  },
  {
    "name": "Bahamas",
    "iso2": "bs",
    "dialCode": "1242"
  },
  {
    "name": "Barbados",
    "iso2": "bb",
    "dialCode": "1246"
  },
  {
    "name": "Anguilla",
    "iso2": "ai",
    "dialCode": "1264"
  },
  {
    "name": "Antigua and Barbuda",
    "iso2": "ag",
    "dialCode": "1268"
  },
  {
    "name": "British Virgin Islands",
    "iso2": "vg",
    "dialCode": "1284"
  },
  {
    "name": "U.S. Virgin Islands",
    "iso2": "vi",
    "dialCode": "1340"
  },
  {
    "name": "Cayman Islands",
    "iso2": "ky",
    "dialCode": "1345"
  },
  {
    "name": "Bermuda",
    "iso2": "bm",
    "dialCode": "1441"
  },
  {
    "name": "Grenada",
    "iso2": "gd",
    "dialCode": "1473"
  },
  {
    "name": "Turks and Caicos Islands",
    "iso2": "tc",
    "dialCode": "1649"
  },
  {
    "name": "Montserrat",
    "iso2": "ms",
    "dialCode": "1664"
  },
  {
    "name": "Northern Mariana Islands",
    "iso2": "mp",
    "dialCode": "1670"
  },
  {
    "name": "Guam",
    "iso2": "gu",
    "dialCode": "1671"
  },
  {
    "name": "American Samoa",
    "iso2": "as",
    "dialCode": "1684"
  },
  {
    "name": "Sint Maarten",
    "iso2": "sx",
    "dialCode": "1721"
  },
  {
    "name": "Saint Lucia",
    "iso2": "lc",
    "dialCode": "1758"
  },
  {
    "name": "Dominica",
    "iso2": "dm",
    "dialCode": "1767"
  },
  {
    "name": "Saint Vincent and the Grenadines",
    "iso2": "vc",
    "dialCode": "1784"
  },
  {
    "name": "Trinidad and Tobago",
    "iso2": "tt",
    "dialCode": "1868"
  },
  {
    "name": "Saint Kitts and Nevis",
    "iso2": "kn",
    "dialCode": "1869"
  },
  {
    "name": "Jamaica",
    "iso2": "jm",
    "dialCode": "1876"
  }
];

export default PHONE_COUNTRIES_BY_DIAL_CODE;
